import { type ReactNode } from 'react';
import { CompassWordmark } from '@bravemove/design-tokens/brand';
import { cn } from '../../utils/cn';

export interface TopNavProps {
  /** Replace the default CompassWordmark with custom branding. */
  readonly brand?: ReactNode;
  /** Centre slot — usually search / breadcrumbs. */
  readonly center?: ReactNode;
  /** End slot — user avatar / notifications / actions. */
  readonly end?: ReactNode;
  readonly className?: string;
}

export function TopNav({ brand, center, end, className }: TopNavProps) {
  return (
    <nav aria-label="Primary" className={cn('h-14 px-4 flex items-center gap-4', className)}>
      <div className="flex items-center gap-2">{brand ?? <CompassWordmark size={20} />}</div>
      {center ? (
        <div className="flex-1 min-w-0 flex items-center">{center}</div>
      ) : (
        <div className="flex-1" />
      )}
      {end ? <div className="flex items-center gap-1">{end}</div> : null}
    </nav>
  );
}
